import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-16 md:py-24 px-4 bg-brand-slate/50 border-y border-white/5" data-id="element-153">
      <div className="max-w-2xl mx-auto text-center" data-id="element-154">
        <FadeIn data-id="element-155">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          type: 'spring'
        }} className="text-7xl md:text-8xl font-serif font-bold text-brand-amber mb-6 drop-shadow-[0_0_30px_rgba(212,165,116,0.2)]" data-id="element-156">
            85%
          </motion.div>
          <p className="text-xl md:text-2xl text-white leading-relaxed mb-4" data-id="element-157">
            En solo 7 días, el 85% de los usuarios reportan una disminución
            drástica en la urgencia física de revisar las redes sociales de su
            ex.
          </p>
          <p className="text-brand-muted font-medium uppercase tracking-widest text-sm" data-id="element-158">
            No es magia, es habituación neuronal.
          </p>
        </FadeIn>
      </div>
    </section>;
}